<template>
  <div class="boxbgcolor api-configure">
    <!--左侧树形展示所有停车场-->
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right configure-right">
      <el-form ref="addOrEditForm" label-width="150px" :rules="rules" :model="payConfigure">
        <!-- <el-form-item label="系统名称" prop='systemname'>
                    
                            <el-input v-model="payConfigure.systemname"></el-input>
                       
        </el-form-item>-->
        <el-form-item label="APPID" prop="appid">
          <el-input v-model="payConfigure.appid" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="商户号" prop="mchid">
          <el-input v-model="payConfigure.mchid" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="密钥" prop="secret">
          <el-input v-model="payConfigure.secret" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="payConfigure.openFlag" label="是否启用" name></el-checkbox>
        </el-form-item>
      </el-form>
      <div class="submit">
        <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  xinjiangUnionPayNosenseConfigureOne,
  xinjiangUnionPayNosenseConfigureAddOrEdit,
} from "@/api/url";

import AreaTree from "@/page/commons/areaTree";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      fileList: [],
      payConfigure: {
        id: "",
        // systemname:'',
        appid: "",
        mchid: "",
        secret: "",
        openFlag: false,
        parkingId: "",
      },
      rules: {
        // systemname: [
        //     { required: true, message: '请填写系统名称', trigger: 'blur' }
        // ],
        appid: [{ required: true, message: "请填APPID", trigger: "blur" }],
        mchid: [{ required: true, message: "请填写商户号", trigger: "blur" }],
        secret: [{ required: true, message: "请填写公钥", trigger: "blur" }],
        // openFlag: [
        //     { required: true, message: '请填写微信公众号名称', trigger: 'blur' }
        // ]
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.resetForm();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.payConfigureOne();
      } else {
        this.treeData.parkingId = "";
        this.payConfigure.id = "";
        this.payConfigure.appid = "";
        this.payConfigure.mchid = "";
        this.payConfigure.secret = "";
        this.payConfigure.openFlag = false;
        // this.$message({
        //         message: '请选择车场！',
        //         type: 'warning'
        // });
      }
      // if(node.level==2){
      // 	this.treeData.parkingId=data.parent.data.id;
      // 	this.treeData.areaId=node.id;
      // }
    },
    payConfigureOne() {
      this.$postRequest(xinjiangUnionPayNosenseConfigureOne(), {
        parkingId: this.treeData.parkingId,
      }).then((data) => {
        if (data.data) {
          this.treeData.parkingId = data.data.parkingId;
          // this.payConfigure.systemname=data.data.systemname;
          this.payConfigure.id = data.data.id;
          this.payConfigure.appid = data.data.appid;
          this.payConfigure.mchid = data.data.mchid;
          this.payConfigure.secret = data.data.secret;
          this.payConfigure.openFlag = data.data.openFlag == "y" ? true : false;
        } else {
          // this.treeData.parkingId='';
          // this.payConfigure.systemname='';
          this.payConfigure.id = "";
          this.payConfigure.appid = "";
          this.payConfigure.mchid = "";
          this.payConfigure.secret = "";
          this.payConfigure.openFlag = false;
        }
      });
    },
    addOrEdit() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
        return;
      }
      this.$refs.addOrEditForm.validate((valid) => {
        if (valid) {
          this.$postRequest(xinjiangUnionPayNosenseConfigureAddOrEdit(), {
            id: this.payConfigure.id,
            parkingId: this.treeData.parkingId,

            appid: this.payConfigure.appid,
            secret: this.payConfigure.secret,
            mchid: this.payConfigure.mchid,
            openFlag: this.payConfigure.openFlag ? "y" : "n",
          }).then((data) => {
            //提交后的操作
            if (data.status != 200) return this.$layer.msg(data.message);
            this.$notify({
              type: "success",
              title: "成功",
              message: "新增或修改配置成功!",
            });
          });
        } else {
        }
      });
    },
    isParkingIdEmpty() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
  },
  computed: {},
  components: {
    AreaTree,
  },

  mounted: function () {},
};
</script>

<style scoped>
.submit {
  text-align: center;
}
</style>
<style>
.api-configure .el-form {
  width: 70%;
  margin: 0 auto;
  margin-top: 50px;
}
.api-configure .content-right .el-input__inner {
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
}
.api-configure .el-form-item {
  margin-bottom: 30px;
}
.api-configure .el-form-item__label {
  height: 50px;
  line-height: 50px;
  color: #333 !important;
  font-weight: bold;
}
.submit .el-button {
  width: 200px;
  height: 50px;
}
.api-configure .el-checkbox__label {
  color: #333 !important;
  font-weight: bold;
}
</style>